import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { NetSuiteAsset } from 'types'

export interface ContractLineAssetManagerState {
  isLoading: boolean
  netSuiteAssets: { [key: number]: NetSuiteAsset }
  error: string | null
  contractLineId: number | null
  setupAdminEmailUserId: number | null
  managerNetSuiteCustomerName: string | null
  managerNetSuiteCustomerNSId: string | null
}

const initialState: ContractLineAssetManagerState = {
  isLoading: false,
  netSuiteAssets: null,
  error: null,
  contractLineId: null,
  setupAdminEmailUserId: null,
  managerNetSuiteCustomerName: null,
  managerNetSuiteCustomerNSId: null,
}

const slice = createSlice({
  name: 'ContractLineAssetManager',
  initialState,
  reducers: {
    clearContractLineAssets(state) {
      state.netSuiteAssets = null
      state.error = null
      state.isLoading = false
      state.contractLineId = null
      state.setupAdminEmailUserId = null
      state.managerNetSuiteCustomerName = null
      state.managerNetSuiteCustomerNSId = null
    },
    fetchingContractLineAssets(state) {
      state.isLoading = true
      state.error = null
    },
    fetchingContractLineAssetsSuccess(
      state,
      action: PayloadAction<NetSuiteAsset[]>,
    ) {
      state.netSuiteAssets = Object.assign(
        {},
        state.netSuiteAssets,
        Object.fromEntries(
          action.payload?.map(asset => [asset.id, asset]) || [],
        ),
      )
      state.isLoading = false
      state.error = null
    },
    fetchingContractLineAssetsError(state, action: PayloadAction<string>) {
      state.isLoading = false
      state.error = action.payload
    },
    fetchingContractLineAssetsNotFound(state, action: PayloadAction<string>) {
      state.isLoading = false
      state.error = action.payload
    },
    setContractLineId(state, action: PayloadAction<number | null>) {
      state.contractLineId = action.payload
    },
    setSetupAdminEmailUserId(state, action: PayloadAction<number | null>) {
      state.setupAdminEmailUserId = action.payload
    },
    setManagerNetSuiteCustomerData(
      state,
      action: PayloadAction<{ name: string | null; nsId: string | null }>,
    ) {
      state.managerNetSuiteCustomerName = action.payload.name
      state.managerNetSuiteCustomerNSId = action.payload.nsId
    },
    updatingContractLineAsset(state) {
      state.isLoading = true
      state.error = null
    },
    updatingContractLineAssetSuccess(
      state,
      action: PayloadAction<NetSuiteAsset>,
    ) {
      // Update the asset in the state with the new assignment data
      if (action.payload && state.netSuiteAssets) {
        state.netSuiteAssets[action.payload.id] = action.payload
      }
      state.isLoading = false
      state.error = null
    },
    updatingContractLineAssetError(state, action: PayloadAction<string>) {
      state.isLoading = false
      state.error = action.payload
    },
  },
})

export const actions = slice.actions
export default slice.reducer
